import { FETCH_BANNERS } from "../actions/types";

export const bannersReducer = (state = [], action) => {
  switch (action.type) {
    case FETCH_BANNERS:
      return action.payload.map((banner) => {
        return { id: banner.id, ...banner.data() };
      });
    default:
      return state;
  }
};
